var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZohoSprints({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 293 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118 148.9H71.2c-4.7 0-8.5-3.8-8.5-8.5s3.8-8.5 8.5-8.5H118c4.7 0 8.5 3.8 8.5 8.5s-3.8 8.5-8.5 8.5zM74.1 191.4H27.4c-4.7 0-8.5-3.8-8.5-8.5s3.8-8.5 8.5-8.5h46.7c4.7 0 8.5 3.8 8.5 8.5s-3.8 8.5-8.5 8.5z",
    fill: "#F9B21D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.9 293c-1.9 0-3.8-.6-5.3-1.8-1.8-1.5-3-3.6-3.2-5.9-1-11 1.9-22.1 7.9-31.3 6.1-9.2 15.2-16.1 25.7-19.5l33.6-10.8-38.8-63.3c-2.2-3.5-1.5-8.1 1.6-10.8l84.7-74.3c6.7-5.9 10.6-14 10.9-22.9.3-8.9-3-17.3-9.3-23.6l-5.1-5.1L35.1 232.9c-6.2 6-9.6 14-9.7 22.7 0 5.9 1.5 11.6 4.5 16.6l113.7-100c3.5-3.1 8.9-2.8 12 .8 3.1 3.5 2.8 8.9-.8 12L34.4 290.8c-3.4 3-8.4 2.8-11.6-.4l-.1-.1c-9.3-9.3-14.4-21.8-14.3-35 .1-13.2 5.4-25.5 14.8-34.7L244.8 5.4c3.3-3.2 8.7-3.2 11.9.1l11 11c4.9 4.9 8.6 10.6 11.1 17 2.4 6.1 3.5 12.6 3.2 19.2-.2 6.6-1.7 13-4.5 19-2.9 6.2-7 11.7-12.1 16.2l-79.3 69.6 40.7 66.4c1.4 2.2 1.6 5 .7 7.4-.9 2.4-2.9 4.3-5.4 5.1l-43.9 14.2c-6.9 2.2-12.8 6.7-16.8 12.7-2.3 3.4-3.9 7.3-4.7 11.3l73.7-10.5c10-1.4 18.5-7.3 23.4-16.1 4.9-8.8 5.3-19.2 1.2-28.4l-29.7-66.9c-1.9-4.3 0-9.3 4.3-11.2 4.3-1.9 9.3 0 11.2 4.3l29.7 66.9c6.3 14.1 5.6 30-1.9 43.5s-20.6 22.6-35.9 24.7l-83.8 12c-.2.1-.6.1-1 .1z",
    fill: "#089949"
  })));
}

export default SvgZohoSprints;